import { render, staticRenderFns } from "./fashidengji.vue?vue&type=template&id=4e29cfac&scoped=true"
import script from "./fashidengji.vue?vue&type=script&lang=js"
export * from "./fashidengji.vue?vue&type=script&lang=js"
import style0 from "./fashidengji.vue?vue&type=style&index=0&id=4e29cfac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e29cfac",
  null
  
)

export default component.exports